import {
  getReportsByGroup,
  getEnps,
  getLnps,
  getReportsHistoryByGroup,
} from '../../service/reports'

const initialState = {
  history: {
    dates: [],
    items: [],
  },
  group: {
    group_name: '',
    isEmptyState: false,
    metrics: [],
    smart_metrics: [],
    score: undefined,
    enps: {},
    lnps: {},
    history: [],
    message: false,
    low_metrics: [],
    date: undefined,
    inactive: false,
  },
}

const state = initialState

const getters = {
  groupName: state => state.group.group_name,
  isEmptyState: state => state.group.isEmptyState,
  metrics: state => state.group.metrics,
  smartMetrics: state => state.group.smart_metrics,
  history: state => state.group.history,
  score: state => state.group.score,
  enps: state => state.group.enps,
  lnps: state => state.group.lnps,
  message: state => state.group.message,
  lowMetrics: state => state.group.low_metrics,
  date: state => state.group.date,
  inactive: state => state.group.inactive,
  reportsHistory: state => state.history,
}

const actions = {
  toggleShowHistoryReport({ commit }, item) {
    commit('toggleShowHistoryReport', item)
  },

  getReportsHistoryByGroup({ commit }, groupId) {
    return getReportsHistoryByGroup(groupId).then(response =>
      commit('setHistory', response.data)
    )
  },

  getReportsByGroup({ commit }, groupId) {
    return getReportsByGroup(groupId).then(reports =>
      commit('setReports', reports)
    )
  },

  getEnps({ commit }, groupId) {
    getEnps(groupId).then(enps => commit('setEnps', enps))
  },

  getLnps({ commit }, groupId) {
    getLnps(groupId).then(lnps => commit('setLnps', lnps))
  },

  reload({ commit, dispatch }, group) {
    commit('reset')
    dispatch('getReportsByGroup', group._id)
    dispatch('getEnps', group._id)
    dispatch('getLnps', group._id)
  },
}

const mutations = {
  toggleShowHistoryReport(state, item) {
    const historyItem = state.history.items.find(({ id }) => id === item.id)
    historyItem.show = !historyItem.show
  },

  setHistory(state, { history, dates }) {
    const items = history.map(i => ({ ...i, show: i.id === 'overall' }))
    state.history = Object.assign(state.history, { dates, items })
  },

  setReports(state, report) {
    state.group = Object.assign({}, state.group, report)
  },

  setEnps(state, enps) {
    if (enps) {
      // --- Mock dos meses restantes ---
      let his = []
      let i =
        new Date(enps.historic[enps.historic.length - 1].date).getMonth() + 1

      while (his.length < 15) {
        if (i >= 12) {
          i = 1
        } else {
          i++
        }

        let monthScore = {
          prop_promoters: 0,
          prop_detractors: 0,
          prop_passives: 0,
          prop_not_answered: 0,
          date: '2018-' + (i < 10 ? '0' + i : i) + '-01',
          score: 0,
        }

        his.push(monthScore)
      }

      for (i = 0; i < enps.historic.length; i++) {
        his.push(enps.historic[i])
      }
      // ------

      Object.assign(enps, { historic: his })
      Object.assign(state.group, { enps })
    }
  },

  setLnps(state, lnps) {
    if (lnps) {
      // --- Mock dos meses restantes ---
      let his = []
      let i =
        new Date(lnps.historic[lnps.historic.length - 1].date).getMonth() + 1

      while (his.length < 15) {
        if (i >= 12) {
          i = 1
        } else {
          i++
        }

        let monthScore = {
          prop_promoters: 0,
          prop_detractors: 0,
          prop_passives: 0,
          prop_not_answered: 0,
          date: '2018-' + (i < 10 ? '0' + i : i) + '-01',
          score: 0,
        }

        his.push(monthScore)
      }

      for (i = 0; i < lnps.historic.length; i++) {
        his.push(lnps.historic[i])
      }
      // ------

      Object.assign(lnps, { historic: his })
      Object.assign(state.group, { lnps })
    }
  },

  reset(state) {
    state.group = {
      metrics: [],
      smart_metrics: [],
      score: undefined,
      enps: {},
      lnps: {},
      message: false,
      lowMetrics: [],
    }
  },

  hideMessage(state) {
    state.group.message = false
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
